import type { FaireProductEntity } from "../../entity_types/product";

export const p_usyg6sxx8v: FaireProductEntity = {
  token: "p_usyg6sxx8v",
  type: "product",
  name: "TRIPLE LEI GIFT BAG",
  brandName: "Homegrown",
  imageUrl:
    "https://cdn.faire.com/fastly/4e29f385fc80c1b414bcf80599f024fad60d1ec8938cf0cc00fe227f18b87656.jpeg",
  priceDollars: 1.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/23683f45b2c01450548ac0da46d1d60e1611eb128688f6bb12b63c331e00f9db.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
